import axios from "axios"
import API_URLS from "../../config/global_variables";
const userData = localStorage.userData?JSON.parse(localStorage.userData):"";

const apidata = async () => {
  try {
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_URLS.GET_FRONT_END_ATTRIBUTES,
      headers: {
        'Content-Type': 'application/json','Authorization': userData.token
      },
      data: JSON.stringify({ is_simple: true }),
    };

    let response = await axios.request(config);   

    if (response.status === 200 && Array.isArray(response.data?.data)) {
      const mappedData = response.data.data.map((item) => {
        const values_data = Array.isArray(item.values_data)
          ? item.values_data.map(val => ({
            frontend_attribute_id: val.frontend_attribute_id,
            id: val.id,
            values: val.values,
          }))
          : [];

        return {
          key: item.id,
          attribute_id: item.id,
          attribute_name: item.attribute_label,
          attribute_key: item.attribute_key,
          max_size: item.max_size,
          updated_at: new Date(item.updated_at).toLocaleString("en-GB"),
          attribute_element_type: item.attribute_element_type,
          values_data: values_data,
          attri_pattern: item.attri_pattern
        };
      });

    
      return mappedData;
    }
    
    return [];
  } catch (error) {
    console.error("error", error);
    return [];
  }
};
const apiHelpers = {
  apidata
};

export default apiHelpers;